import React from 'react';
import { Card, CardContent, CardHeader, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

import type { TestProps } from '../../models';
import { fCurrency } from '../../utils/formatNumber';

interface TestsProps {
	tests: Array<Omit<TestProps, 'price'> & { price?: number }>;
}

/*
 Selected tests review before submission
*/
export const TestReview = ({ tests }: TestsProps) => {
	const hasPrice = tests.some((test) => typeof test.price === 'number');

	return (
		<Card variant="outlined">
			<CardHeader title="Item Details" sx={{ color: 'grey.600' }} />
			<CardContent>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>Name</TableCell>
							<TableCell>Qty</TableCell>
							{hasPrice && <TableCell>Price</TableCell>}
							{hasPrice && <TableCell>Line Total</TableCell>}
						</TableRow>
					</TableHead>
					<TableBody>
						{tests.map((test) => (
							<TableRow key={test.id}>
								<TableCell>{test.name}</TableCell>
								<TableCell>{test.quantity}</TableCell>
								{hasPrice && <TableCell>{fCurrency(test.price)}</TableCell>}
								{hasPrice && <TableCell>{fCurrency((test.price as number) * (test.quantity || 1))}</TableCell>}
							</TableRow>
						))}
					</TableBody>
				</Table>
			</CardContent>
		</Card>
	);
};
